<template>

  <section>

    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="getPosts"
    >
      <van-cell
        v-for="item in posts"
        :key="item.id"
        is-link
        clickable
        :url="item.link.replace('mhelp','help')"
        :title="item.title.rendered"
      />
    </van-list>
  </section>

</template>

<script>
import { Cell, List } from "vant";
import ClientApi from '@/assets/js/clientApi.js'
export default {
  props: {
    propsId: String
  },
  components: {
    // "van-cell-group": CellGroup,
    "van-cell": Cell,
    "van-list": List
  },
  data () {
    return {
      loading: false,
      finished: false,
      page: 1,
      id: this.$route.query.id || this.propsId,
      posts: []
    };
  },
  async created () {
    // this.getPosts();
    this.$route.query.title && ClientApi.getApi('setTitleJS', this.$route.query.title)
  },
  methods: {
    async getPosts () {
      try {
        let data = await this.$http.get(
          "/wp-json/wp/v2/posts?categories=" + this.id + "&order=asc" + "&page=" + this.page++
        );

        if (!data || data.length <= 0) {
          // 加载状态结束
          this.loading = false;
          this.finished = true;
          return;
        }
        // 加载状态结束
        this.loading = false;
        this.posts = this.posts.concat(data);
        if (data.length < 10) {
          this.finished = true;
        }
      } catch (error) {
        // 加载状态结束
        this.loading = false;
        this.finished = true;
      }

    }
  }
};
</script>
<style lang="scss" scoped>
.normal {
  font-size: 28px;
  text-align: center;
  padding: 20px;
  height: 100vh;
}
</style>
